module.exports = __webpack_public_path__ + "static/media/emojiIcon.91433c03.svg";